// extracted by mini-css-extract-plugin
export var drawerContent = "_2y-0";
export var valueBlock = "_2y-1";
export var valueBlockFrom = "_2y-2 _2y-1";
export var valueBlockTo = "_2y-3 _2y-1";